import ListAttendanceIndicator from './ListAttendanceIndicator';

export default ListAttendanceIndicator;
